export const STRIPE_SUCCESS = 'payment/STRIPE_SUCCESS';
export const STRIPE_ERROR = 'payment/STRIPE_ERROR';

export const PROFILE_STRIPE_SUCCES = 'payment/PROFILE_STRIPE_SUCCES';
export const PROFILE_STRIPE_ERROR = 'payment/PROFILE_STRIPE_ERROR';

export const VIPPS_SUCCESS = 'payment/VIPPS_SUCCESS';
export const VIPPS_ERROR = 'payment/VIPPS_ERROR';

export const MOBILE_PAY_SUBMIT = 'payment/MOBILE_PAY_SUBMIT';
export const MOBILE_PAY_REDIRECT = 'payment/MOBILE_PAY_REDIRECT';


export const SUBMIT_ADYEN_CARD_REGISTER = 'payment/SUBMIT_ADYEN_CARD_REGISTER';
export const ADYEN_SUCCESS = 'payment/ADYEN_SUCCESS';
export const ADYEN_ERROR = 'payment/ADYEN_ERROR';
export const SUBMIT_ADYEN_CARD_ADDITIONAL_DETAILS = 'payment/SUBMIT_ADYEN_CARD_ADDITIONAL_DETAILS';


export const SWISH_PAY_SUBMIT = 'payment/SWISH_PAY_SUBMIT';
export const SWISH_PAY_SUBMIT_ADDITIONAL_DETAILS = 'payment/SWISH_PAY_SUBMIT_ADDITIONAL_DETAILS';

export const GOOGLE_PAY_SUBMIT = 'payment/GOOGLE_PAY_SUBMIT';

export const APPLE_PAY_SUBMIT = 'payment/APPLE_PAY_SUBMIT';
